if (!customElements.get('kdo-personalization-choice')) {
  customElements.define('kdo-personalization-choice', class extends HTMLElement {
    connectedCallback() {
      this.choice = this.querySelector('[data-kdo-choice]');
      this.message = this.querySelector('[data-kdo-message]');
      this.photo = this.querySelector('[data-kdo-photo]');
      this.details = this.querySelector('[data-kdo-details]');
      this.property = this.querySelector('[data-kdo-property]');
      this.onChange = () => {
        const custom = this.choice.value === 'custom';
        this.details.hidden = !custom;
        this.message.disabled = !custom;
        this.message.required = custom;
        if (this.photo) this.photo.disabled = !custom;
        this.property.disabled = !this.choice.value;
        this.property.value = this.choice.selectedOptions[0].textContent.trim();
      };
      this.choice.addEventListener('change', this.onChange);
      this.onChange();
      const scope = this.closest('.product__info-container');
      if (scope) {
        const replaceGenericText = () => {
          const replacedSelector = this.photo ? '.po-textField-input, .po-field-root input[type="file"]' : '.po-textField-input';
          scope.querySelectorAll(replacedSelector).forEach(input => {
            const root = input.closest('.po-field-root');
            if (root && !root.classList.contains('kdo-replaced-option')) root.classList.add('kdo-replaced-option');
          });
        };
        this.observer = new MutationObserver(replaceGenericText);
        this.observer.observe(scope, { childList: true, subtree: true });
        replaceGenericText();
      }
    }
    disconnectedCallback() {
      this.choice?.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
    }
  });
}
